import { OrderProject as IOrderProject } from '@types';

import * as moment from 'moment';
import { CharacterModel } from './CharacterModel';
import { ProjectModel } from './ProjectModel';

export class OrderProjectModel extends ProjectModel implements IOrderProject {
    price: number[] = [];
    order_characters: CharacterModel[] = [];
    order_character_list: [] = [];
    order: {} = {};

    constructor({
        id,
        nazov,
        zaciatok,
        vytvoril,
        klient,
        characters,
        id_klient,
        detail,
        price,
        order_character_list,
        na_schvalenie,
        schvaleny,
        schvalenie_email,
        schvalil,
        datum_odoslane,
        odoslal,
        datum_schvalenia,
        hasOrder,
        order,
        zobrazit_do,
        blacklist,
        blacklist_ids,
        prolongs,
        status,
        directorscut_url,
    }: IOrderProject) {
        super({
            id,
            nazov,
            zaciatok,
            vytvoril,
            klient,
            characters,
            id_klient,
            detail,
            na_schvalenie,
            schvaleny,
            schvalenie_email,
            schvalil,
            datum_odoslane,
            odoslal,
            datum_schvalenia,
            hasOrder,
            zobrazit_do,
            blacklist,
            blacklist_ids,
            prolongs,
            order,
            status,
            directorscut_url,
        });
        this.price = price;
        this.order_character_list = order_character_list;
        this.order = order;
    }
}
